import { FC, useContext } from "react";
import KickImage from 'Reuseables/KickImage';

// Helpers
import { formatCurrency } from "../../../../utils/Helpers";

//Context
import ShipperContext from "../context";

//Interface
import { LogisticCardInterface } from "./definitions";

const LogisticCard: FC<LogisticCardInterface> = ({
  selected,
  data,
  onSelectHandler,
  checkCourierExpired
}) => {
  const { ratio, currency } = useContext(ShipperContext);

  const { logistic, rate, max_day, min_day, final_price } = data || {};
  const oneEta = max_day == min_day;
  const RenderDay = (day) => day > 1 ? "days" : "day";
  const RenderEtaText = () => oneEta ? <p className="eta">ETA delivery: {min_day} {RenderDay(min_day)}</p> : <p className="eta">ETA delivery: {min_day} {RenderDay(min_day)} - {max_day} {RenderDay(max_day)}</p>
  
  const timeExceed = checkCourierExpired(max_day ?? 0);

  return (
    <div className={`logistic-card ${timeExceed ? "exceed" : selected ? "selected" : ""}`} onClick={() => !timeExceed && onSelectHandler(data)}>
      <KickImage src={logistic.logo_url} alt="card" />
      <div className="text-wrapper">
        <p className="title">{logistic?.name} - {rate?.type}</p>
        {
          timeExceed ? <p className="eta">This option is no longer <br/> available due to time limit</p> : RenderEtaText()
        }
      </div>
      <p className="price">{formatCurrency(final_price, ratio, currency)}</p>
    </div>
  )
}

export default LogisticCard;